import baseAPI from "../api/baseApi";
import { authHeader, authHeaderWithImage } from "../helpers/authHeader";

const getOffers = async (data) => {
  try {
    const res = await baseAPI.get(
      `/get-offers?page=${data.page}&search=${data.search}&discount_type=${data.discount_type ? data.discount_type : ""}`,
      {
        headers: authHeader(),
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getCustomerSecondTimeOfferPending = async (merchantId) => {
  try {
    const res = await baseAPI.get(
      `/customer-second-time-offer-pending/${merchantId}`,
      {
        headers: authHeader(),
      }
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const addOffer = async (data) => {
  try {
    const formdata = new FormData();

    data.branch_id.forEach((branch, i) => {
      formdata.append(`branch_id[${i}]`, branch.value);
    });

    data.sub_category_id.forEach((subcategory, i) => {
      formdata.append(`sub_category_id[${i}]`, subcategory.value);
    });

    formdata.append("category_id", data.category_id?.value);
    // if (Array.isArray(data.category_id)) {
    //   data.category_id.forEach((cat, index) => {
    //     formdata.append(`category_id[${index}]`, cat.value);
    //   });
    // } else {
    //   formdata.append("category_id", data.category_id);
    // }
    formdata.append("offer_type", data.offer_type);
    formdata.append("discount_type", data.discount_type);
    if (data.discount_type == "1") {
      formdata.append("discount_value", data.discount_value);
      formdata.append("max_amount", data.max_amount);
      formdata.append("min_amount", "");
      formdata.append("second_transaction_expire_date", "");
    } else if (data.discount_type == "2") {
      formdata.append("discount_value", data.discount_value_for_flat_discount);
      formdata.append("max_amount", "");
      formdata.append("min_amount", data.min_amount);
      formdata.append("second_transaction_expire_date", "");
    } else if (data.discount_type == "3") {
      formdata.append("discount_value", "");
      formdata.append("max_amount", "");
      formdata.append("min_amount", "");
      formdata.append("second_transaction_expire_date", "");
    } else if (data.discount_type == "4") {
      formdata.append("discount_value", data.discount_value);
      formdata.append("max_amount", "");
      formdata.append("min_amount", "");
      formdata.append("second_transaction_expire_date", data.second_transaction_expire_date);
    }
    formdata.append("offer_limit", data.offer_limit);
    formdata.append("title_en", data.title_en);
    formdata.append("title_ar", data.title_ar);
    formdata.append("description_en", data.description_en);
    formdata.append("description_ar", data.description_ar);
    formdata.append("team_conditation_en", data.team_conditation_en);
    formdata.append("team_conditation_ar", data.team_conditation_ar);
    formdata.append("expiry_date", data.expiry_date);
    formdata.append(
      "is_executive_offer",
      data.is_executive_offer == true ? 1 : 0
    );
    formdata.append("offer_image", data.offer_image);

    const res = await baseAPI.post(`/add-offer`, formdata, {
      headers: authHeaderWithImage(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getOfferById = async (id) => {
  try {
    const res = await baseAPI.get(`/get-offer-details?offer_id=${id}`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getOfferRedemptionData = async (offerId) => {
  try {
    const res = await baseAPI.get(`/offer-redemption-data/${offerId}`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const editOffer = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append(`offer_id`, data.offer_id);
    formdata.append(`merchant_id`, data.merchant_id);
    data.branch_id.forEach((branch, i) => {
      formdata.append(`branch_id[${i}]`, branch.value);
    });

    data.sub_category_id.forEach((subcategory, i) => {
      formdata.append(`sub_category_id[${i}]`, subcategory.value);
    });

    formdata.append("category_id", data.category_id?.value);
    formdata.append("offer_type", data.offer_type);
    formdata.append("discount_type", data.discount_type);
    if (data.discount_type == "1") {
      formdata.append("discount_value", data.discount_value);
      formdata.append("max_amount", data.max_amount);
      formdata.append("min_amount", "");
      formdata.append("second_transaction_expire_date", "");
    } else if (data.discount_type == "2") {
      formdata.append("discount_value", data.discount_value_for_flat_discount);
      formdata.append("max_amount", "");
      formdata.append("min_amount", data.min_amount);
      formdata.append("second_transaction_expire_date", "");
    } else if (data.discount_type == "3") {
      formdata.append("discount_value", "");
      formdata.append("max_amount", "");
      formdata.append("min_amount", "");
      formdata.append("second_transaction_expire_date", "");
    } else if (data.discount_type == "4") {
      formdata.append("discount_value", data.discount_value);
      formdata.append("max_amount", "");
      formdata.append("min_amount", "");
      formdata.append("second_transaction_expire_date", data.second_transaction_expire_date);
    }
    formdata.append("offer_limit", data.offer_limit);
    formdata.append("title_en", data.title_en);
    formdata.append("title_ar", data.title_ar);
    formdata.append("description_en", data.description_en);
    formdata.append("description_ar", data.description_ar);
    formdata.append("team_conditation_en", data.team_conditation_en);
    formdata.append("team_conditation_ar", data.team_conditation_ar);
    formdata.append("expiry_date", data.expiry_date);
    formdata.append(
      "is_executive_offer",
      data.is_executive_offer == true ? 1 : 0
    );
    formdata.append("offer_image", data.offer_image);

    const res = await baseAPI.post(`/edit-offer`, formdata, {
      headers: authHeaderWithImage(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const deleteOffer = async (data) => {
  const formdata = new FormData();
  formdata.append("offer_id", data.offer_id);

  try {
    const res = await baseAPI.post(`/delete-offer`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
const OfferService = {
  getOffers,
  getCustomerSecondTimeOfferPending,
  addOffer,
  getOfferById,
  getOfferRedemptionData,
  editOffer,
  deleteOffer,
};

export default OfferService;
